import { ReturnPage } from '../components/pages'

export default ReturnPage
